/**
 * Listado de balanceadores.
 *
 * Las columnas van en el orden en que se lee una fila: que es el grupo
 * (identificacion) -> como esta configurado -> que resultados tuvo -> cuando se
 * creo. `total` abre el bloque de resultados porque es la referencia de la que
 * salen los demas contadores.
 */
export default {
    fields: [
        /* ---------- Identificacion ---------- */
        {
            key: "_selected",
            label: "",
            sortable: false,
            filter: false,
            _filter: false,
            _style: "width:5%",
        },
        {
            key: "id",
            label: "#",
            sorter: false,
            active: true,
            filter: false,
            _filter: true,
            fixed: true,
            _style: "width:5%",
        },
        {
            key: "name",
            label: "name",
            sorter: true,
            filter: true,
            _filter: true,
            fixed: false,
            active: true,
        },
        // `active` no se pinta como columna: el estado va como punto de color
        // delante del nombre. Sigue disponible en TableSettings, porque llega
        // en el payload y de ahi se construye la lista de columnas activables.
        // Entradas y salidas: solo el icono con el numero. Los nombres
        // rompian la tabla al desbordarse, asi que el detalle va en un modal.
        {
            key: "campaigns",
            label: "inputs",
            sorter: false,
            filter: false,
            _filter: false,
            fixed: false,
            _active: true,
            _style: "width:6%",
            _classes: "text-center",
        },
        {
            // El payload llama `salidas` a los clientes miembros del grupo.
            key: "salidas",
            label: "outputs",
            sorter: false,
            filter: false,
            _filter: false,
            fixed: false,
            _active: true,
            _style: "width:6%",
            _classes: "text-center",
        },

        /* ---------- Configuracion ---------- */
        // `shipment_balancing_type` no se pinta como columna: va como icono
        // delante del nombre, con el nombre del tipo en el tooltip. Sigue
        // disponible en TableSettings porque llega en el payload.
        // `return_priority_response` tampoco se pinta como columna: es un flag,
        // y va como icono delante del nombre solo cuando esta activo.

        /* ---------- Resultados ----------
         * El endpoint devuelve `stats: { leads_in, delivered, attempts, ok }`,
         * que mezcla dos niveles a proposito:
         *
         *   nivel ENVIO  attempts (Total), ok (OK)
         *   nivel LEAD   leads_in (Unicos), delivered (Entregados)
         *
         * Por eso `Total` puede ser mayor que `Unicos` (1 lead -> N salidas), y
         * `OK` puede ser mayor que `Entregados` en ToAll, donde un mismo lead
         * sale OK por varias salidas. Con capping_count_ok = 1 coinciden.
         *
         * `not_delivered` (leads_in - delivered) y `delivery_rate` se derivan
         * en el front.
         *
         * El orden lo hace el ENDPOINT: `adapterBalancerGroupsQuery` traduce
         * la clave sintetica (`stats_leads_in`) al campo real (`leads_in`).
         * Por eso ordena sobre el total y no solo sobre la pagina visible.
         *
         * `not_delivered` y `delivery_rate` siguen sin ser ordenables: se
         * derivan en el front y el endpoint no los conoce.
         */
        {
            key: "stats_attempts",
            label: "total_attempts",
            sorter: true,
            filter: false,
            _filter: false,
            fixed: false,
            active: true,
            _active: true,
            _style: "width:8%",
            _classes: "text-center",
        },
        {
            key: "stats_leads_in",
            label: "leads_in",
            sorter: true,
            filter: false,
            _filter: false,
            fixed: false,
            active: true,
            _active: true,
            _style: "width:7%",
            _classes: "text-center",
        },
        {
            key: "stats_ok",
            label: "ok",
            sorter: true,
            filter: false,
            _filter: false,
            fixed: false,
            active: true,
            _active: true,
            _style: "width:6%",
            _classes: "text-center",
        },
        {
            key: "stats_delivered",
            label: "delivered",
            sorter: true,
            filter: false,
            _filter: false,
            fixed: false,
            active: true,
            _active: true,
            _style: "width:8%",
            _classes: "text-center",
        },
        {
            key: "stats_not_delivered",
            label: "not_delivered",
            sorter: false,
            filter: false,
            _filter: false,
            fixed: false,
            active: true,
            _active: true,
            _style: "width:8%",
            _classes: "text-center",
        },
        {
            key: "stats_delivery_rate",
            label: "delivery_rate",
            sorter: false,
            filter: false,
            _filter: false,
            fixed: false,
            active: true,
            _active: true,
            _style: "width:8%",
            _classes: "text-center",
        },
        /* ---------- Metadata ---------- */
        {
            key: "created_at",
            label: "created_at",
            sorter: false,
            filter: false,
            _filter: false,
            _style: "width:10%",
            _type: "Date",
        },
    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    // `external: true`: ordena el endpoint, no la tabla. Sin esto CDataTable
    // reordenaria ademas la pagina visible y podria no coincidir con el orden
    // que devuelve el servidor.
    sorter: { external: true, resetable: true },
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true,
    },
    columnFilterValue: {},
    // El mixin lo lee para construir el `order` del query.
    sorterValue: {},
    itemsPerPageSelect: true,
    itemSelected: null,
};
